// FIXME: Update this configuration file based on your project information

import type { Locale } from '@/i18n/types';
import { MARKET_LOCALES } from '@/libs/market/market';

export const AppConfig = {
  name: 'Sweep King',
  title: 'Sweep King',
  description: 'Legal online casino platform',
  locale: 'en',
  defaultLocale: MARKET_LOCALES.US as Locale,
  country: 'US',
  email: 'support@sweepking.com',
};
